import { translate } from '@/translation/translate.ts';
import { Slide } from '@/eventConfig/types.ts';
import { FC } from 'react';
import { useSaveRegistration } from '@/saveRegistration/useSaveRegistration.ts';
import { useNavigation } from '@/navigation/NavigationContex.ts';

interface GridCheckTextProps {
  slide: Slide;
}

export const GridCheckText: FC<GridCheckTextProps> = ({ slide }) => {
  const { gotoSlide } = useNavigation();
  const { gridStatus, gridCheck } = useSaveRegistration();

  const retryGridCheck = () => {
    gridCheck();
  };

  const gotoScan = () => {
    gotoSlide('scanGrid');
  };

  switch (gridStatus) {
    case 'unknown':
      return (
        <>
          <span>{translate(slide?.gridCheck?.checking)}</span>
          <span></span>
        </>
      );
    case 'checking':
      return (
        <>
          <span>{translate(slide?.gridCheck?.checking)}</span>
          <span></span>
        </>
      );
    case 'usable':
      return (
        <>
          <span>{translate(slide?.gridCheck?.success)}</span>
          <span></span>
        </>
      );
    case 'used':
      return (
        <>
          <span>{translate(slide?.gridCheck?.alreadyUsed)}</span>
          <div>
            <button onClick={gotoScan}>{translate(slide?.gridCheck?.back)}</button>
          </div>
        </>
      );
    case 'error':
      return (
        <>
          <span>{translate(slide?.gridCheck?.failure)}</span>
          <div>
            <button onClick={retryGridCheck}>{translate(slide?.gridCheck?.retry)}</button>
          </div>
        </>
      );
    default:
      return (
        <>
          <span>{translate(slide?.gridCheck?.failure)}</span>
          <div>
            <button onClick={retryGridCheck}>{translate(slide?.gridCheck?.retry)}</button>
          </div>
        </>
      );
  }
};
